import React, { useState } from 'react';
import { useNavigate } from 'react-router';

import { Check as IconCheck } from "flowbite-react-icons/outline";
import Api from "../../services/Api";
import CustomButton from "../../components/CustomButton";
import AlertIcon from "../../components/Icons/AlertIcon";


export default function SignUp() {
    const api = Api.getInstance()
    const navigate = useNavigate();
    const [email, setEmail] = useState('');
    const [error, setError] = useState('');
    const [errorName, setErrorName] = useState('');

    const submit = () => {
        const data = {
            email: email
        }
        api.postRaw('coach/signup', data).then(response => {
            response.json().then(json => {
                console.log(json)
                if (json.error) {
                    setError(json.error)
                    setErrorName(json.name)
                    console.log('Error name is ' + json.name)
                } else {
                    setError('')
                }
                if (json.status === 'ok') {
                    const inviteCode = json.inviteCode
                    if (inviteCode && inviteCode.length > 8) {
                        window.location.replace("/accept_invite/" + inviteCode);
                    }
                }
            }).catch((err) => alert(err))
        }).catch((err) => alert(err))
    }

    return (
      <div className="main-content">
        <h1 className="text-2xl font-medium mt-6">
          Welcome to Zebrain!
        </h1>

        <p className="mt-2 text-neutral-400">
          We’re excited that you’re considering joining our platform! Before applying,
          please review the requirements and process outlined below to ensure we’re a great match.
        </p>

        <hr className="mt-6 border-neutral-600"/>

        <h2 className="text-2xl font-medium mt-6">
          Our requirements
        </h2>

        <p className="mt-2 text-neutral-400">
          We require all our coaches to meet the following criteria:
        </p>

        <div className="mt-4 flex">
          <IconCheck className="h-6 text-neutral-900!" aria-hidden="true" />
          <div className="ml-1">
            <div className="text-lg font-medium">Certification:</div>
            <p className="text-neutral-400">
              Hold a valid coach certification (e.g. from ICF).
            </p>
          </div>
        </div>

        <div className="mt-4 flex">
          <IconCheck className="h-6 text-neutral-900!" aria-hidden="true" />
          <div className="ml-1">
            <div className="text-lg font-medium">Experience:</div>
            <p className="text-neutral-400">
              A minimum of 200 logged coaching hours.
            </p>
          </div>
        </div>

        <hr className="mt-6 border-neutral-600"/>

        <h2 className="text-2xl font-medium mt-6">
          The process on how to become a coach
        </h2>

        <p className="mt-4 text-neutral-400">
          Here is the process overview:
        </p>

        <div className="mt-4 flex">
          <div className="text-lg font-medium">1.</div>
          <div className="ml-1">
            <div className="text-lg font-medium">Submit your application</div>
            <p className="text-neutral-400">
              Complete the application form (approximately 15–20 minutes).
            </p>
          </div>
        </div>

        <div className="mt-4 flex">
          <div className="text-lg font-medium">2.</div>
          <div className="ml-1">
            <div className="text-lg font-medium">Application review</div>
            <p className="text-neutral-400">
              Our team will carefully review your application.
            </p>
          </div>
        </div>

        <div className="mt-4 flex">
          <div className="text-lg font-medium">3.</div>
          <div className="ml-1">
            <div className="text-lg font-medium">Set up your profile</div>
            <p className="text-neutral-400">
              If approved, you’ll receive an email with a link to create your public presentation
              and set your availability.
            </p>
          </div>
        </div>

        <div className="mt-4 flex">
          <div className="text-lg font-medium">4.</div>
          <div className="ml-1">
            <div className="text-lg font-medium">Start coaching</div>
            <p className="text-neutral-400">
              Once your profile is live, you can begin receiving session bookings!
            </p>
          </div>
        </div>

        <hr className="mt-6 border-neutral-600"/>

        <h2 className="text-2xl font-medium mt-6">
          Next Step - Enter your email to apply
        </h2>

        <p className="mt-4 text-neutral-400">
         Please enter the e-mail that you want to create your account with in the next step.
        </p>

        <input className="z-input mt-2" type="text" value={email}
               onChange={(e) => setEmail(e.target.value)}
               placeholder="coach@gmail.com"/>

        {
          error.length > 0 &&
            <div className="mt-6 p-4 bg-neutral-700 border rounded-md border-cherry-500 flex items-center">
                <AlertIcon aria-label="Error" className="text-cherry-500!"/>
                <div className="ml-2">
                    <p className="font-medium">
                      {error}
                    </p>
                </div>
            </div>
        }

        {
          errorName === 'already_created' ?
            <CustomButton className="mt-4" onClick={() => navigate('/')}>
              Go to platform.zebrain.se
            </CustomButton>
            :
            <CustomButton className="mt-6" onClick={() => submit()}>Next</CustomButton>
        }
      </div>
    )
}
